import React from 'react';
import {find as _find, isArray as _isArray, join as _join} from 'lodash';

import * as CONST from '@constants/variables';
import {sortByTextValue} from '@utils/sorters';
import {EventContentVariantPopup} from '@utils/eventContentVariant/EventContentVariantPopup';
import {IconAngleRight} from '@appComponents/IconCollection';

export const prepareClients = (row, column) => {
    const clientsArray = [];

    row[column].map((client) => {
        clientsArray.push(client.name);
    });

    switch (parseInt(row.client_selection_type.id, 10)) {
        case CONST.CLIENT_SELECTION_TYPE_ALL:
            return 'All';
        case CONST.CLIENT_SELECTION_TYPE_BLACKLIST:
            return 'All except ' + _join(clientsArray, ', ');
        case CONST.CLIENT_SELECTION_TYPE_WHITELIST:
        default:
            return _join(clientsArray, ', ');
    }
};

export const prepareEventContents = (row, column) => {
    let eventContents = 'All';

    if (!row.includes_all_event_contents) {
        eventContents = row[column].map((eventContent) =>
            ({
                name: eventContent.event_content_type.name + ((eventContent.name) ? ' - ' + eventContent.name : ''),
                variant: eventContent.event_content_variant})
        );
        eventContents = sortByTextValue(eventContents, 'name');
    }

    return (!_isArray(eventContents))
        ? eventContents
        : eventContents.map((eventContent, i) =>
            <p key={i} className='--noMargin'>{eventContent.name}
                <EventContentVariantPopup eventContentVariant={eventContent.variant}/>
            </p>
        );
};

export const prepareUsages = (usages) => {
    let usagesArray = [];

    const handleDeviceCategory = (deviceCategory, product, usage) => {
        deviceCategory
            ? deviceCategory.way_of_transmissions.push(usage.way_of_transmission.name)
            : product.device_categories.push({
                name: usage.device_category.name,
                way_of_transmissions: [usage.way_of_transmission.name],
            });
    };

    usages.map((usage) => {
        let product = _find(usagesArray, {name: usage.product.short_name}),
            deviceCategory = (product)
                ? _find(product.device_categories, {name: usage.device_category.name})
                : undefined;

        (product)
            ? handleDeviceCategory(deviceCategory, product, usage)
            : usagesArray.push({
                name: usage.product.short_name,
                device_categories: [{
                    name: usage.device_category.name,
                    way_of_transmissions: [usage.way_of_transmission.name],
                }],
            });
    });

    return usagesArray;
};

export const renderUsages = (usages) => {
    return (
        prepareUsages(usages).map((product) =>
            product.device_categories.map((deviceCategory, i) =>
                <p key={i} className='--noMargin'>
                    {product.name}<IconAngleRight/>
                    <span key={i}>
                        {deviceCategory.name}
                        <IconAngleRight/>
                        {_join(deviceCategory.way_of_transmissions, ' / ')}
                    </span>
                </p>
            )
        )
    );
};
